/**
 * The query part of a URL, as it arrives from the router.
 *
 * A stored return-to query may or may not carry its leading `?`, so the two
 * spellings are reconciled once here instead of at each navigation site.
 */
export function withLeadingQuestionMark(query: string): string {
  return query.startsWith("?") ? query : `?${query}`;
}

/** The query with no leading `?`, for storing or comparing. */
export function withoutLeadingQuestionMark(query: string): string {
  return query.startsWith("?") ? query.slice(1) : query;
}
